import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import RoomsListTable from './roomsList/RoomsListTable';
import CreateRoomModal from './createRoom/CreateRoomModal';
import PageHeader from '../../components/common/header/PageHeader';

export default function RoomsPage(): JSX.Element {
    const {t} = useTranslation();

    const [open, setOpen] = useState(false);

    return (
        <>
            <div className="l-container">
                <PageHeader title={t('navigation.rooms')} />
                <RoomsListTable onCreateRoom={() => setOpen(true)} />
            </div>
            <CreateRoomModal open={open} setOpen={setOpen} />
        </>
    );
}
